import {
  USER_PROFILE_PAGES,
  MATCHES_ORGANISATIONS_OPTIONS,
  BRAND_DOCUMENTS,
  DEFAULT_BRAND,
  USER_ACCESS_LEVEL
} from '../../utils/constants';
import { COMMON_COOKIES_MAP, getCookie } from 'ecx.saigon.ui.common';
import _merge from 'lodash/merge';

/**
 * True if the user should be blocked from the application
 * @param state
 * @returns {boolean}
 */
export function userBlocked(state) {
  return state.user.accessLevel === USER_ACCESS_LEVEL.CREDIT_ONLY;
}

export function hasAccessAfterCalculator(state) {
  return state.user.accessLevel === USER_ACCESS_LEVEL.APPLICATION;
}

export function getBrandDocuments(state) {
  if (BRAND_DOCUMENTS.hasOwnProperty(state.user.entity)) {
    return BRAND_DOCUMENTS[state.user.entity];
  }
  return BRAND_DOCUMENTS[DEFAULT_BRAND];
}

export function theme(state) {
  return () => {
    const brand = brandName(state)();
    const defaultBrand = _merge(
      {},
      state.ORGBranding?.defaultBrand,
      state.ORGBranding?.defaultBrand?.[brand]
    );
    const novatedBrand = _merge(
      {},
      state.ORGBranding?.novated,
      state.ORGBranding?.novated?.[brand]
    );
    return {
      defaultBrand,
      novatedBrand
    };
  };
}

export function brandName(state) {
  return () => {
    const cookieEntity = getCookie(COMMON_COOKIES_MAP.brandName.key);
    return state.user.entity || cookieEntity;
  };
}

export function hasMultipleOrganisationMatches(state) {
  return (
    state.user.profile.matchesOrganisations ===
    MATCHES_ORGANISATIONS_OPTIONS.multiple
  );
}

export function isProfileSetupComplete(state) {
  return profileSetupCompletePercentage(state) === 100;
}

export function canUserCreateQuote(state) {
  if (requiresOrganisationSelection(state)) {
    return false;
  }

  return (
    state.user.profile.contactNumber &&
    state.user.profile.corporateEmailVerified
  );
}

function requiresOrganisationSelection(state) {
  return !state.user.hasOrganisation && hasMultipleOrganisationMatches(state);
}
function requiresEmailOrEmployerName(user) {
  return !user.profile.companyEmail && !user.profile.noCorporateEmail;
}
function requiresEmploymentType() {
  return false;
}
function requiresPostcode(user) {
  return !user.profile.postcode;
}
function requiresContactNumber(user) {
  return !user.profile.contactNumber;
}

/**
 * Return the first profile stepper page that to pass the page validation
 */
export function profileSetupPage(state) {
  if (requiresEmailOrEmployerName(state.user)) {
    return USER_PROFILE_PAGES.employerDetails;
  }
  if (requiresOrganisationSelection(state)) {
    return USER_PROFILE_PAGES.organisationSelection;
  }
  if (requiresEmploymentType(state.user)) {
    return USER_PROFILE_PAGES.employmentType;
  }
  if (requiresPostcode(state.user)) {
    return USER_PROFILE_PAGES.postcode;
  }
  return USER_PROFILE_PAGES.contactNumber;
}

/**
 * Return the percentage of profile pages that have been complete
 */
export function profileSetupCompletePercentage(state) {
  let percentageIncrement = 100 / Object.keys(USER_PROFILE_PAGES).length;
  let percentageDone = 0;
  if (!requiresEmailOrEmployerName(state.user)) {
    percentageDone += percentageIncrement;
  }
  if (!requiresOrganisationSelection(state)) {
    percentageDone += percentageIncrement;
  }
  if (!requiresEmploymentType(state.user)) {
    percentageDone += percentageIncrement;
  }
  if (!requiresPostcode(state.user)) {
    percentageDone += percentageIncrement;
  }
  if (!requiresContactNumber(state.user)) {
    percentageDone += percentageIncrement;
  }
  return percentageDone;
}
